export enum TableCellVerticalAlignmentStyle {
    Bottom = "bottom",
    Middle = "middle",
    Top = "top",
    None = "",
}
